<template>
  <FormItem v-bind="$attrs" v-on="$listeners" :label="label">
    <RadioGroup v-bind="$attrs" v-on="$listeners">
      <Radio
        v-for="(item, index) in items"
        :key="index"
        :value="item[valuePath]"
        :label="item[valuePath]"
        :disabled="disabled"
      >
        <span>{{ item[labelPath] }}</span>
      </Radio>
    </RadioGroup>
  </FormItem>
</template>

<script>
import { Radio, FormModel } from "ant-design-vue";

const RadioGroup = Radio.Group;

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    valuePath: {
      type: String,
      default: "value"
    },
    labelPath: {
      type: String,
      default: "label"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  components: {
    Radio,
    RadioGroup,
    FormItem: FormModel.Item
  }
};
</script>
